import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Introduce from "../components/Introduce";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index,
            title: "主页"
        },
        {
            path: '/Introduce',
            name: 'Introduce',
            component: Introduce,
            title: "简介子主页面"
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js